import { withStyles, withTheme } from 'material-ui';
import React, { Component } from 'react';
import Page from '../components/Page';
import TermContent from '../resource_content/TermContent';
import AppBarSpacing from '../utils/AppBarSpacing';

class Term extends Component {
  render() {
    var info = this.props.resources[this.props.resourceID];
    var description = info.description;
    var docID = info.resourceID;
    var url = info.url;
    if(!description && !docID && url) {
      window.location.replace(url);
    }
    return (
      <Page containerProps={{className: this.props.classes['margin-app_bar_spacing-1']}}>
        <main>
          <TermContent resourceID={this.props.resourceID} resources={this.props.resources}/>
        </main>
        
      </Page>
    );
  }
}

export default withTheme()(withStyles(AppBarSpacing)(Term));


// WEBPACK FOOTER //
// ./src/resource_views/Term.js